(function (window, document) {
    document.addEventListener('DOMContentLoaded', function () {
        const dialog = document.querySelector('.media-lightbox');
        if (!dialog || !dialog.showModal) {
            return;
        }

        const content = dialog.querySelector('.media-lightbox-content');
        const desktop = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
        let activeMedia;
        let resumePlayer;

        function open(media) {
            if (!desktop.matches || dialog.open) {
                return;
            }

            activeMedia = media;
            resumePlayer = media.currentState === 'playing';
            if (resumePlayer) {
                media.pause();
            }

            const isImage = media.tagName === 'IMG';
            dialog.setAttribute('aria-label', isImage ? dialog.dataset.imageLabel : dialog.dataset.animationLabel);
            const enlarged = document.createElement(isImage ? 'img' : 'lottie-player');
            if (isImage) {
                enlarged.alt = media.alt;
                if (media.closest('picture')) {
                    // Preserve the selected picture source, which may differ from the fallback image.
                    enlarged.src = media.currentSrc || media.src;
                } else {
                    // Let the browser choose a larger source for the popup when one is available.
                    enlarged.sizes = '(min-width: 1472px) 1408px, calc(100vw - 64px)';
                    enlarged.srcset = media.srcset;
                    enlarged.src = media.src;
                }
                if (media.naturalWidth && media.naturalHeight) {
                    content.style.aspectRatio = media.naturalWidth + ' / ' + media.naturalHeight;
                }
                enlarged.addEventListener('load', function () {
                    if (enlarged.isConnected && enlarged.naturalWidth && enlarged.naturalHeight) {
                        content.style.aspectRatio = enlarged.naturalWidth + ' / ' + enlarged.naturalHeight;
                    }
                });
            } else {
                // Keep the original in place: moving a Lottie player destroys its animation.
                ['src', 'background', 'speed', 'loop', 'mode', 'direction', 'renderer', 'preserveAspectRatio', 'description'].forEach(function (attribute) {
                    if (media.hasAttribute(attribute)) {
                        enlarged.setAttribute(attribute, media.getAttribute(attribute));
                    }
                });
                enlarged.setAttribute('autoplay', '');
                enlarged.addEventListener('ready', function () {
                    // Also clean up if the popup was closed while its JSON was loading.
                    if (!enlarged.isConnected) {
                        enlarged.destroy();
                        return;
                    }
                    const animation = enlarged.getLottie().animationData;
                    content.style.aspectRatio = animation.w + ' / ' + animation.h;
                    enlarged.resize();
                }, {once: true});
            }
            content.appendChild(enlarged);
            document.documentElement.classList.add('media-lightbox-open');
            dialog.showModal();
        }

        dialog.querySelector('.media-lightbox-close').addEventListener('click', function () {
            dialog.close();
        });

        desktop.addEventListener('change', function () {
            if (!desktop.matches && dialog.open) {
                dialog.close();
            }
        });

        dialog.addEventListener('click', function (event) {
            const bounds = dialog.getBoundingClientRect();
            if (event.target === dialog && (
                event.clientX < bounds.left || event.clientX > bounds.right ||
                event.clientY < bounds.top || event.clientY > bounds.bottom
            )) {
                dialog.close();
            }
        });

        dialog.addEventListener('close', function () {
            content.replaceChildren();
            content.style.aspectRatio = '';
            document.documentElement.classList.remove('media-lightbox-open');
            if (resumePlayer) {
                activeMedia.play();
            }
            activeMedia.focus({preventScroll: true});
            activeMedia = null;
        });

        // Preserve links, image maps, and players with their own playback controls.
        document.querySelectorAll('.post-content lottie-player:not([controls]), .post-content img').forEach(function (media) {
            if (media.closest('a, button') || media.hasAttribute('usemap')) {
                return;
            }
            const label = media.tagName === 'IMG' ? dialog.dataset.openImageLabel : dialog.dataset.openAnimationLabel;
            const description = media.getAttribute('aria-label') || media.getAttribute('alt') || media.getAttribute('description');
            const zoomAttributes = {
                role: 'button',
                tabindex: '0',
                'aria-haspopup': 'dialog',
                'aria-label': description ? label + ': ' + description : label,
                title: label
            };
            const originalAttributes = {};
            Object.keys(zoomAttributes).forEach(function (attribute) {
                originalAttributes[attribute] = media.getAttribute(attribute);
            });

            function updateMedia() {
                media.classList.toggle('media-zoomable', desktop.matches);
                const attributes = desktop.matches ? zoomAttributes : originalAttributes;
                Object.keys(attributes).forEach(function (attribute) {
                    if (attributes[attribute] === null) {
                        media.removeAttribute(attribute);
                    } else {
                        media.setAttribute(attribute, attributes[attribute]);
                    }
                });
            }

            updateMedia();
            desktop.addEventListener('change', updateMedia);
            media.addEventListener('click', function () {
                open(media);
            });
            media.addEventListener('keydown', function (event) {
                if (desktop.matches && (event.key === 'Enter' || event.key === ' ')) {
                    event.preventDefault();
                    open(media);
                }
            });
        });
    });
})(window, document);
